<template>
  <div class="card-sections-block-header-tmk">

    <el-row type="flex" justify="space-between" style="margin-bottom: 20px">
      <div style="font-size: 24px">
        Цели деятельности и развития
      </div>
      <cards-select-and-clone-elements-modal @elements-cloned="reloadCard">
        <el-button
          slot="reference"
          size="mini"
          icon="far fa-clone"
        >
          Копировать из карты
        </el-button>
      </cards-select-and-clone-elements-modal>
      <div>
        <div v-if="card.info && card.info.type === cardTypesEnum.TYPE_GOALS" style="display: inline-block; margin-right: 40px">
          <div
            v-if="card.info && card.info.format === 2 && card.status===$constants.card.statuses.STATUS_COMPLETED || ( currentStage && currentStage.type === $constants.stage.types.TYPE_ASSESSMENT && currentStage.current_negotiation_id)"
          >
            <div>Итого вес целей, факт: {{weightTotalSum}} %</div>
          </div>
        </div>

        <div v-if="card.info && card.info.type === cardTypesEnum.TYPE_KPI" style="display: inline-block; margin-right: 40px">
          <div >
            <span style="margin-right: 40px">Вес КПЭ: {{weightPlanTotalSum}} %</span>
            <span v-if="isWeightFactHidden">Взвешенный коэффициент выполнения КПЭ: Скрыто</span>
            <span v-else>Взвешенный коэффициент выполнения КПЭ: {{weightTotalSum}} %</span>
          </div>
        </div>


        <history-modal
          v-if="$canAndRulesPass(card, 'card.see_history')"
          style="display: inline-block; margin-left:35px"
          title="История изменений карты"
          width="70%"
          show-model-full-name
          :method="$api.card.getCardHistory"
          :params="{  id: card.id }"
        >
          <el-button
            slot="reference"
            type="text"
            size="mini"
            icon="fas fa-history"
          >
            История изменений
          </el-button>
        </history-modal>

        <el-button
          v-if="$canAndRulesPass(card, $permissions.CARD.EXPORT)"
          style="margin-left:35px"
          type="text"
          size="mini"
          icon="fas fa-file-excel"
          :loading="loadingDownloader"
          @click="exportToExcel"
        >
          Экспорт в XLSX
        </el-button>
      </div>
    </el-row>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import HistoryModal from "@/components/HistoryModal.vue";
import {downloader} from "@/mixins/downloader";
import requestSender from "@/api/base/requestSender";
import ClickToEdit from "@/components/ClickToEdit.vue";
import {cardInfoField} from "@/mixins/cardInfoField";
import { variables } from "@/componentsCompany/smz/variables";
import CardsSelectAndCloneElementsModal from "@/components/cards/CardSelectAndCloneElementModal.vue";

export default {
  name: "card-sections-block-header",
  mixins: [downloader, cardInfoField],
  components: {CardsSelectAndCloneElementsModal, ClickToEdit, HistoryModal},
  props: {},

  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card:'card'
    }),
    ...mapGetters('card/stages', {
      currentStage: 'currentStage',
    }),
    ...mapGetters('card/sections', {
      sections: 'sections',
      sectionsElements: 'sectionsElements'
    }),
    weightTotalSum() {
      let totalWeight = 0;

      this.sections.forEach(section => {
        // Пропускаем эти секции
        if( ['career', 'growth'].includes(section.type) ){
          return
        }

        if( !this.sectionsElements[section.id] ){
          return;
        }
        this.sectionsElements[section.id].forEach(e => {
          totalWeight += +e.scale.weight_fact;
        })
      })

      return +totalWeight.toFixed(2);
    },
    isWeightFactHidden() {
      return this.user.id === this.card.user_id && !this.card.info?.total_evaluations_visibility;
    },
    weightPlanTotalSum() {
      let totalWeightPlan = 0;

      this.sections.forEach(section => {
        // Пропускаем эти секции
        if( ['career', 'growth', 'kpi_dart_trr'].includes(section.type) ){
          return
        }

        if( !this.sectionsElements[section.id] ){
          return;
        }
        this.sectionsElements[section.id].forEach(e => {
          totalWeightPlan += +e.scale.weight_plan;
        })
      })

      return +totalWeightPlan.toFixed(2);
    },
  },
  watch: {},
  data() {
    return {
      cardTypesEnum: variables.cardTypesEnum,
      loadingNotify: false,
    }
  },
  methods: {
    changeBonus(){
      this.infoFieldChanged('final_estimate')
        .then(()=>{
          this.$store.dispatch('card/loadCardData');
          this.$store.dispatch('card/stages/loadStages');
        })
    },
    exportToExcel() {
      this.downloadFile(
        'export.xlsx',
        this.$api.exportImport.export,
        {
          entity: (this.card.info.type === this.cardTypesEnum.TYPE_GOALS ? 'card' : 'cardKpi'),
          data: {
            id: this.card.id
          }}
      )
    },
    reloadCard() {
      this.$store.dispatch('card/loadCard', {id: parseInt(this.$route.params.id)});
    },
  }
}
</script>


<style lang="scss" scoped>

</style>